// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoSquareFilledSvg from "@fishx/icons-svg/es/asn/TaobaoSquareFilled";
import FishxIcon from '../components/FishxIcon';

var TaobaoSquareFilled = function TaobaoSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoSquareFilledSvg
  }));
};

TaobaoSquareFilled.displayName = 'TaobaoSquareFilled';
export default React.forwardRef(TaobaoSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TaobaoSquareFilled.js
// module id = 4254
// module chunks = 0